var React = require('react');

function CloseCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-close_circle"},React.createElement("rect",{"width":"20","height":"20"}))),React.createElement("g",{"id":"close_circle","clipPath":"url(#clip-close_circle)","key":1},[React.createElement("circle",{"id":"Elipse_1","data-name":"Elipse 1","cx":"10","cy":"10","r":"10","fill":"#f2f2f2","key":0}),React.createElement("path",{"id":"Trazado_14","data-name":"Trazado 14","d":"M13,7,7,13","fill":"none","stroke":"#6e7b8a","strokeLinejoin":"round","strokeWidth":"1.5","key":1}),React.createElement("path",{"id":"Trazado_15","data-name":"Trazado 15","d":"M13,7,7,13","transform":"translate(0 20) rotate(-90)","fill":"none","stroke":"#6e7b8a","strokeLinejoin":"round","strokeWidth":"1.5","key":2})])]);
}

CloseCircle.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = CloseCircle;

CloseCircle.default = CloseCircle;
